import { Controller } from "@hotwired/stimulus";

// Controller for express submit reference review.
export default class extends Controller {
  static targets = ["submit"];

  handleAdditionalReference(event) {
    this.submitTarget.dataset.turbo = event.target.value === "true";
  }
}
